let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ldNZs")).then(() => parcelRequire('U4Few'));